module.exports = __webpack_public_path__ + "static/media/wizard-form-lazy.80367fce.jpg";